import React, {useContext, useState} from "react";
import {
  Avatar,
  Button,
  Stack,
  Toolbar,
  Typography,
  AppBar,
  IconButton,
  Menu, Box, MenuItem, useTheme, ListItemIcon, ListItemText
} from "@mui/material";
import {Link, NavLink} from "react-router-dom";
import {
  IconBulldozer,
  IconLogout,
  IconMenu,
  IconUser
} from "@tabler/icons-react";
import {SignInContext} from "../../../context/SignInContext";
import {grey} from "@mui/material/colors";
import {HeaderDrawer} from "./HeaderDrawer";
import {WebSettingsContext} from "../../../context/WebSettingsContext";

export const Header = () => {
  const {isAuth, currentUser, onLogout, openModal} = useContext(SignInContext);
  const [openDrawer, setOpenDrawer] = useState(false);

  const theme = useTheme();

  const isAdmin = currentUser?.roles?.includes("admin")


  return (
    <>
      <HeaderDrawer
        open={openDrawer}
        handleClose={() => setOpenDrawer(false)}
        openCart={() => {
          setOpenDrawer(false);
        }}
      />

      <AppBar position="static"
              sx={{
                bgcolor: "transparent",
                boxShadow: 0,
                zIndex: 100,
                borderBottom: 0,
                minHeight: "48px !important",
                borderColor: "divider"
              }}
      >
        <Toolbar
          sx={{
            bgcolor: "transparent",
            // display: "none",
            zIndex: 100,
            py: 1, px: 2,
            minHeight: "48px !important",
          }}
        >
          <Stack direction={"row"} sx={{width: "100%"}} gap={2} justifyContent={"space-between"}
                 alignItems={"center"}>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <Button
                component={Link}
                to={"/projects"}
                variant={"text"}
                sx={{flexDirection: "row", color: "dark.main"}}
                startIcon={<img src={"/logo.svg"} alt={"logo"} width={30}/>}
              >
                <Typography fontWeight={700}>BlockFlow</Typography>
              </Button>
            </Stack>

            <Stack direction={"row"} gap={1} alignItems={"center"}>
              {isAdmin && <>
                <Button
                  component={NavLink}
                  to={"/"}
                  sx={{
                    borderRadius: 0,
                    textTransform: "capitalize",
                    color: "dark.main",
                    "&.active": {
                      bgcolor: grey[200],
                      borderRadius: 1,
                      fontWeight: 500
                    }
                  }}
                >
                  Projects
                </Button>
                <Button
                  component={NavLink}
                  to={"/organizations"}
                  sx={{
                    borderRadius: 0,
                    textTransform: "capitalize",
                    color: "dark.main",
                    "&.active": {
                      bgcolor: grey[200],
                      borderRadius: 1,
                      fontWeight: 500
                    }
                  }}
                >
                  Organizations
                </Button>
                <Button
                  component={NavLink}
                  to={"/ai-models"}
                  sx={{
                    borderRadius: 0,
                    textTransform: "capitalize",
                    color: "dark.main",
                    "&.active": {
                      bgcolor: grey[200],
                      borderRadius: 1,
                      fontWeight: 500
                    }
                  }}
                >
                  AI Models
                </Button>
              </>}

              {
                isAuth ?
                  <UserAvatar currentUser={currentUser} onLogout={onLogout} theme={theme}/>
                  :
                  <Button
                    onClick={() => openModal()}
                    sx={{
                      bgcolor: "transparent",
                      borderRadius: 0,
                      textTransform: "capitalize",
                      fontSize: 14,
                      px: 2,
                      fontWeight: "bold",
                      color: '#4a4a4a',
                      borderColor: "#4a4a4a",
                      border: 1,
                      "&:hover": {
                        color: "#FFF",
                        bgcolor: "#4a4a4a"
                      }
                    }}
                  >
                    Sign in
                  </Button>
              }

            </Stack>
          </Stack>
        </Toolbar>

        <Toolbar
          sx={{
            bgcolor: "transparent",
            my: 1,
            display: {xs: 'none', md: "none"}
          }}
        >
          <Stack direction={"row"} sx={{width: "100%"}} gap={2} justifyContent={"space-between"}
                 alignItems={"center"}>
            <Button
              component={Link}
              to={"/projects"}
              variant={"text"}
              sx={{color: "#252525", flexDirection: "column"}}
            >
              <img src={"/logo.svg"} alt={"logo"} width={50}/>
              {/*<Typography fontSize={13} fontColor={"#252525"} fontWeight={"bold"}>BlockFlow</Typography>*/}
            </Button>

            <IconButton onClick={() => setOpenDrawer(true)}>
              <IconMenu/>
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>
    </>
  )
}

export const UserAvatar = ({currentUser, onLogout}) => {
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const isAdmin = currentUser?.roles?.includes("admin")
  const {settings, onUnderMaintenance} = useContext(WebSettingsContext);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const logoutHandle = async () => {
    try {
      await onLogout();
      handleCloseUserMenu();
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <Box sx={{flexGrow: 0}}>
      <Button
        onClick={handleOpenUserMenu}
        size={"small"}
        sx={{
          borderRadius: "8px !important",
          minWidth: "0 !important",
        }}
      >
        <Avatar
          sx={{bgcolor: grey[200]}}
        />
      </Button>
      <Menu
        sx={{p: 0, borderRadius: 0, minWidth: "280px"}}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        MenuListProps={{sx: {borderRadius: 4, minWidth: "200px"}}}
        PaperProps={{sx: {borderRadius: 4, minWidth: "200px"}}}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <Stack direction={"row"} gap={1} alignItems={"center"}
               sx={{px: 2, py: 1, borderBottom: 1, borderColor: "divider"}}>
          <Avatar sx={{width: "35px", height: '35px', bgcolor: grey[100]}}><IconUser color={grey[600]} size={20}/></Avatar>
          <Typography fontWeight={"bold"}>{currentUser?.name} {currentUser?.lastname}</Typography>
        </Stack>
        {
          isAdmin &&
          <MenuItem onClick={onUnderMaintenance}
                    color={settings?.underMaintenance ? "error" : "primary"}
                    sx={{borderBottom: 1, borderColor: "divider", px: 3, py: 1, fontSize: 16}}>
            <ListItemIcon>
              <IconBulldozer/>
            </ListItemIcon>
            <ListItemText primary={"Under Maintenance"}/>
          </MenuItem>
        }
        <MenuItem onClick={logoutHandle}
                  sx={{px: 3, py: 1, fontSize: 16}}>
          <ListItemIcon>
            <IconLogout/>
          </ListItemIcon>
          <ListItemText primary={"Logout"}/>
        </MenuItem>
      </Menu>
    </Box>
  )
}
